.field {
  min-width: 0;
  margin-block: 28px;
  padding-top: 24px;
  border-top: 1px solid var(--yo-line, #deded8);
}
.label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 700;
}
.hint,
.note,
.status {
  margin: 0 0 12px;
  color: var(--yo-muted, #64645e);
  font-size: 12px;
  line-height: 1.8;
}
.note {
  margin-bottom: 0;
}
.preview {
  display: grid;
  justify-items: start;
  gap: 8px;
  margin: 16px 0;
}
.preview img {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 240px;
  object-fit: contain;
  background: #f4f3eb;
}
.preview figcaption {
  max-width: 100%;
  overflow-wrap: anywhere;
  color: var(--yo-muted, #64645e);
  font-size: 12px;
}
.actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
}
.field .input {
  position: absolute;
  width: 1px;
  height: 1px;
  min-height: 0;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
.choose {
  min-height: 44px;
  padding: 10px 16px;
  border: 1px solid var(--yo-ink, #171714);
  border-radius: 0;
  background: #fff;
  color: var(--yo-ink, #171714);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
}
.choose:hover {
  background: var(--yo-yellow, #ffeb00);
}
.choose:focus-visible,
.input:focus-visible + .choose,
.remove:focus-visible {
  outline: 3px solid var(--yo-blue, #2456c8);
  outline-offset: 3px;
}
.remove {
  min-height: 44px;
  padding: 8px 0;
  border: 0;
  background: transparent;
  color: var(--yo-ink, #171714);
  font-size: 12px;
  text-decoration: underline;
  text-underline-offset: 4px;
  cursor: pointer;
}
.choose:disabled,
.remove:disabled {
  opacity: 0.5;
  cursor: wait;
}
.status {
  margin: 8px 0;
}
.status:empty {
  margin: 0;
}
.error {
  margin: 8px 0;
  color: #b42318;
  font-size: 12px;
  line-height: 1.8;
}
@media (prefers-reduced-motion: reduce) {
  .choose {
    transition: none;
  }
}
